/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ScholarshipTypeLinkViewModel } from "../types/ScholarshipTypeLinkViewModel.ts";
import { scholarshipTypeLinkLangViewModelSchema } from "./scholarshipTypeLinkLangViewModelSchema.ts";

export const scholarshipTypeLinkViewModelSchema = z.object({
  classStudentCode: z.string().describe("Código da turma do link.").nullish(),
  linkLang: z
    .array(z.lazy(() => scholarshipTypeLinkLangViewModelSchema))
    .describe("Links da turma, um para cada idioma disponível.")
    .nullish(),
}) as unknown as ToZod<ScholarshipTypeLinkViewModel>;
